import React, { useEffect, useState } from "react";
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  SplineSeries,
  DateTime,
  Tooltip,
  Legend,
} from "@syncfusion/ej2-react-charts";

const TotalUsers = ({ chartsData, skills, selectedSkill }) => {
  const [usersPerSkillData, setUsersPerSkillData] = useState({});

  useEffect(() => {
    const skillMap = Object.fromEntries(skills.map((s) => [s.Id, s.Name]));
    const tempData = {};

    chartsData?.forEach((entry) => {
      const date = new Date(entry.date);
      entry.skills.forEach((skill) => {
        const skillName = skillMap[skill.skillId] || `Skill ${skill.skillId}`;
        if (!tempData[skillName]) tempData[skillName] = [];
        tempData[skillName].push({ x: date, y: skill.uniqueUser });
      });
    });

    setUsersPerSkillData(tempData);
  }, [chartsData, skills]);

  const onAxisLabelRender = (args) => {
    if (args.axis.name === "primaryYAxis") {
      const numericValue = Number(args.text);
      if (!Number.isInteger(numericValue)) args.cancel = true;
    }
  };

  const hasData = Object.keys(usersPerSkillData).length > 0;

  return (
    <div className="chart-display-width">
      <h3>Total Users per Skill</h3>
      {!hasData ? (
        <div className="container-no-records">No Records Found</div>
      ) : (
        <>
          <ChartComponent
            primaryXAxis={{ valueType: "DateTime", labelFormat: "MMM dd" }}
            primaryYAxis={{
              title: "Total Users",
              minimum: 0,
              labelFormat: "{value}",
              rangePadding: "None",
            }}
            tooltip={{ enable: true }}
            legendSettings={{ visible: false }}
            axisLabelRender={onAxisLabelRender}
          >
            <Inject services={[SplineSeries, DateTime, Tooltip, Legend]} />
            <SeriesCollectionDirective>
              {hasData ? (
                Object.entries(usersPerSkillData).map(([skillName, points]) => (
                  <SeriesDirective
                    key={skillName}
                    dataSource={points}
                    xName="x"
                    yName="y"
                    name={skillName}
                    type="Spline"
                    width={2}
                    marker={{ visible: true }}
                  />
                ))
              ) : (
                <SeriesDirective
                  key="empty"
                  dataSource={[]}
                  xName="x"
                  yName="y"
                  name="No Data"
                  type="Spline"
                />
              )}
            </SeriesCollectionDirective>
          </ChartComponent>
          <div className="chart-text-display">
            
              {skills.find((s) => s.Id === parseInt(selectedSkill))?.Name ||
                "Selected Skill"}
            
          </div>
        </>
      )}
    </div>
  );
};

export default TotalUsers;
